<template>
  <div class="snow-switch">
    <b-form-checkbox
      v-model="innerValue"
      switch
      @change="v => $emit('change', v)"
    >
      <div class="d-flex">
        <span class="text-dark ml-3">
          {{ label }}
          <span v-if="required" class="text-negative-700">*</span>
        </span>
        <bp-tooltip v-if="info" :text="info">
          <i class="ph ph-info ml-3 fs-16" />
        </bp-tooltip>
      </div>
    </b-form-checkbox>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean
    },
    label: {
      type: String
    },
    required: {
      type: Boolean
    },
    info: {
      type: String
    },
    id: {
      type: String,
      default: "snow-switch"
    }
  },
  data() {
    return {
      innerValue: this.value
    };
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal;
    },
    innerValue(newVal) {
      this.$emit("input", newVal);
    }
  }
};
</script>
<style lang="scss" scoped>
.snow-switch {
  min-height: 32px;
  display: flex;
  align-items: center;
  ::v-deep {
    .custom-switch {
      display: flex;
      padding-left: 32px;

      .custom-control-label {
        &::before {
          box-shadow: none;
          left: -32px;
          width: 32px;
          height: 18px;
          border-radius: 9px;
          border-color: #cccccc;
          background-color: #cccccc;
        }
        &::after {
          top: 6px;
          left: -30px;
          width: 14px;
          height: 14px;
          border-radius: 100%;
          background-color: #fff;
        }
      }

      &:has(.custom-control-input:checked) {
        .custom-control-label {
          &::before {
            border-color: black;
            background-color: black;
          }
          &::after {
            transform: translateX(14px);
            background-color: #fff;
          }
        }
      }
    }
  }
}
</style>
